import React from 'react';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFavoriteThunk } from '@/store/thunks/favoriteThunk/favoriteThunk';
interface DesignFavoriteButtonProps {
    eachDesign: any;
    fontSize?: string;
}
const DesignFavoriteButton: React.FC<DesignFavoriteButtonProps> = ({ eachDesign, fontSize = '20px' }) => {
    const dispatch = useDispatch()
    const favoritedDesign = useSelector((state: any) => state.favorite.designs[eachDesign.itemId])
    function handleFavorite() {
        dispatch(toggleFavoriteThunk({ postData: { itemId: eachDesign.itemId, isFavorite: favoritedDesign?.isFavorite, type: 'design', itemAdditionalData: eachDesign } }) as any);
    }
    return (
        <Box component='div'>
            {!favoritedDesign?.isFavorite && <FavoriteBorderIcon onClick={handleFavorite} sx={{ fontSize, cursor: 'pointer', color: '#000' }} />}
            {favoritedDesign?.isFavorite && <FavoriteIcon onClick={handleFavorite} sx={{ fontSize, cursor: 'pointer', color: '#FE6526' }} />}
        </Box>
    );
};
export default DesignFavoriteButton;